import * as React from "react";
import { Filter, getKeywordFilterItem } from "azure-devops-ui//Filter";
import { IListBoxItem } from "azure-devops-ui//ListBox";
import { AggregateItemProvider } from "azure-devops-ui//Utilities/AggregateItemProvider";
import {
    Filter as FilterStore,
    FILTER_CHANGE_EVENT,
    IFilterState
} from "azure-devops-ui//Utilities/Filter";
import { GroupedItemProvider } from "azure-devops-ui//Utilities/GroupedItemProvider";
import { groupedItems, groups, statusItems } from "./Data";

export default class FilterExample extends React.Component<{}, any> {
    private provider: AggregateItemProvider<IListBoxItem>;
    private filterStore = new FilterStore();
    private groupedProvider = new GroupedItemProvider([], [], true);
    private filterItems = [
        getKeywordFilterItem(this.filterStore),
        { name: "Status", id: "status", items: statusItems, filterItemKey: "status" },
        {
            name: "Group Items",
            id: "groupItems",
            items: this.groupedProvider,
            filterItemKey: "groupItems"
        }
    ];

    constructor(props: {}) {
        super(props);
        this.provider = new AggregateItemProvider<IListBoxItem>();
        this.groupedProvider.push(...groupedItems);
        this.groupedProvider.pushGroups(...groups);
        this.provider.push(statusItems);
        this.provider.push(this.groupedProvider);

        this.filterStore.subscribe(this.onFilterChanged, FILTER_CHANGE_EVENT);
        this.state = {
            currentState: ""
        };
    }

    public render() {
        return (
            <div style={{ margin: "8px" }}>
                <Filter
                    filterStore={this.filterStore}
                    filterItems={this.filterItems}
                    items={this.provider}
                />
                <div style={{ marginTop: "16px" }} className="monospaced-text">
                    <span>Current state:</span>
                    <span>{this.state.currentState}</span>
                </div>
            </div>
        );
    }

    private onFilterChanged = (changedState: IFilterState) => {
        this.setState({
            currentState: JSON.stringify(this.filterStore.getState(), null, 4)
        });
    };
}
